export default function getAuditModalProps(transactionNumber, values) {
  const { sourceId, documentType } = values.rowData;
  return {
    formId: documentType === 'NOMINAL_ACCRUAL' || documentType === 'NOMINAL_PREPAYMENT' ? transactionNumber : sourceId,
    transactionNumber: transactionNumber,
    forceReadOnly: true,
  };
}
